import { appQueryClient, useAppInfiniteQuery } from '@libs/data-access/queries'

import type {
  PaginatedQueryResponse,
  UseAppInfiniteQueryOptions
} from '../../../../types'
import type { FetchUnassignedShiftsData } from '../shift.api'
import {
  fetchUnassignedShifts,
  type FetchUnassignedShiftsOptions
} from '../shift.api'
import { shiftCacheKeys } from '../shift.cacheKeys'

export const useFetchUnassignedShifts = (
  request: FetchUnassignedShiftsOptions,
  queryOptions?: UseAppInfiniteQueryOptions<
    PaginatedQueryResponse<FetchUnassignedShiftsData, 'pages'>
  >
) => {
  return useAppInfiniteQuery(
    shiftCacheKeys.action.getUnassigned(request.queryParams),
    ({ pageParam }) => fetchUnassignedShifts(request, Number(pageParam)),
    queryOptions
  )
}

export const unassignedInvalidation = () =>
  appQueryClient.invalidateQueries({
    queryKey: shiftCacheKeys.action.getAllUnassigned()
  })
